/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EntityUserInput } from '../../models/entity-user-input';
import { Response } from '../../models/response';

export interface ApiKeycloakUpdateUserPost$Json$Params {
  Authorization?: string;
      body?: EntityUserInput
}

export function apiKeycloakUpdateUserPost$Json(http: HttpClient, rootUrl: string, params?: ApiKeycloakUpdateUserPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
  const rb = new RequestBuilder(rootUrl, apiKeycloakUpdateUserPost$Json.PATH, 'post');
  if (params) {
    rb.header('Authorization', params.Authorization, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Response>;
    })
  );
}

apiKeycloakUpdateUserPost$Json.PATH = '/api/keycloak/UpdateUser';
